import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=08bf1a2e&scoped=true&"
import script from "./monitor.vue?vue&type=script&lang=js&"
export * from "./monitor.vue?vue&type=script&lang=js&"
import style0 from "./monitor.vue?vue&type=style&index=0&id=08bf1a2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf1a2e",
  null
  
)

export default component.exports